/* eslint-disable import/no-unresolved */

import { Container } from "react-bootstrap";
import {
  // AudioElement,
  ImageElement,
  // ModalComponent,
  NoDataFound,
  TimelineModal,
  VideoElement,
} from "components/UiElement";
import { dayJsDateFormatter, checkValidData } from "utils";
import { ext } from "helpers";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { textFormatter } from "components/Formatter";

const preprocessTimelineData = (timelineData) => {
  let lastYearDisplayed = null;
  return timelineData.map((item) => {
    const year = dayJsDateFormatter(item.date, "YYYY");
    const showYear = year !== lastYearDisplayed;
    lastYearDisplayed = year;
    return { ...item, showYear };
  });
};

function TimelineSection03({
  showTimelineModal,
  timelineData,
  timelineModal,
  timeLineModalClose,
  timeLine,
  setTimeline,
}) {
  const processedData = useMemo(
    () => preprocessTimelineData(timelineData),
    [timelineData]
  );

  return (
    <>
      <section className="timelineSec py-80" id="timeline">
        <Container>
          <div className="d-flex">
            <div className="commonHead mb-0 d-flex">
              <div className="commonHead_img rounded-circle d-flex align-items-center justify-content-center flex-shrink-0">
                <ImageElement
                  className="img-fluid"
                  source="theme03/timeline-img.png"
                  alt="timeline"
                />
              </div>
              <div>
                <div className="commonHead_sub mb-xxl-3 mb-0">
                  Narratives of a Lifetime
                </div>
                <h2 className="commonHead_title">
                Highlights of a Life Well Lived
                </h2>
              </div>
            </div>
          </div>
          <ul className="timelineSec_list list-unstyled position-relative pb-sm-4 mb-0">
            {processedData.length > 0 ? (
              processedData.map((item, index) => (
                <React.Fragment key={index}>
                  {item.showYear && (
                    <li className="timelineSec_item d-flex pb-0">
                      <div className="timelineSec_time flex-shrink-0">
                        <div className="year text-center position-relative z-1">
                          {dayJsDateFormatter(item.date, "YYYY")}
                        </div>
                      </div>
                    </li>
                  )}
                  <li className="timelineSec_item d-flex">
                    <div className="timelineSec_time flex-shrink-0">
                      <div className="date d-flex align-items-center flex-column justify-content-center position-relative z-1">
                        {dayJsDateFormatter(item?.date, "MMM")}
                        <span>{dayJsDateFormatter(item?.date, "DD")}</span>
                      </div>
                    </div>
                    <div className="timelineSec_box d-md-flex align-items-center">
                      {ext?.[item?.timelineImageUrl?.split(".").pop()] !==
                      "file" ? (
                        <div className="timelineSec_box_img flex-shrink-0 overflow-hidden">
                          {ext?.[item?.timelineImageUrl?.split(".").pop()] ===
                            "image" && (
                            <div
                              className="timelineSec_box_img flex-shrink-0 overflow-hidden"
                              onClick={() => showTimelineModal(item?.id, item)}
                            >
                              <ImageElement
                                className="h-100 w-100 object-fit-cover"
                                id="img1"
                                previewSource={item?.timelineImageUrl}
                                alt="evolution-01"
                              />
                            </div>
                          )}
                          {ext?.[item?.timelineImageUrl?.split(".").pop()] ===
                            "video" && (
                            <div
                              className="timelineSec_box_img flex-shrink-0 overflow-hidden  overflow-hidden video"
                              onClick={() => showTimelineModal(item?.id, item)}
                            >
                              <VideoElement
                                className="h-100 w-100 object-fit-cover"
                                previewSource={item?.timelineImageUrl}
                                controls={false}
                              />
                              <span className="timelineSec_box_icon">
                                <em className="icon-video" />
                              </span>
                            </div>
                          )}
                          {ext?.[item?.timelineImageUrl?.split(".").pop()] ===
                            "audio" && (
                            <div
                              className="timelineSec_box_img audio flex-shrink-0 overflow-hidden"
                              onClick={() => showTimelineModal(item?.id, item)}
                            >
                              <span className="timelineSec_box_icon">
                                <em className="icon-mic" />
                              </span>
                            </div>
                          )}
                        </div>
                      ) : (
                        <Link
                          to={item?.timelineImageUrl}
                          target="_blank"
                          className="timelineSec_box_img flex-shrink-0 overflow-hidden"
                        >
                          {ext?.[item?.timelineImageUrl?.split(".").pop()] ===
                            "file" && (
                            <div className="timelineSec_box_img pdf flex-shrink-0">
                              <Link
                                className="timelineSec_box_icon"
                                to={item?.timelineImageUrl}
                                target="_blank"
                              >
                                <em className="icon-pdf" />
                              </Link>
                            </div>
                          )}
                        </Link>
                      )}
                      <div className="timelineSec_box_txt text-break">
                        <h3 className="title">
                          {checkValidData(textFormatter(item?.title))}
                        </h3>
                        <p className="mb-0">
                          {checkValidData(textFormatter(item?.description))}
                        </p>
                      </div>
                    </div>
                  </li>
                </React.Fragment>
              ))
            ) : (
              <NoDataFound />
            )}
          </ul>
          {/* <Row className="position-relative justify-content-end g-0 d-none d-sm-flex">
            <Col xxl={6} sm={5}>
              <span className="timelineSec_bottom" />
              <ImageElement
                className="img-fluid ms-auto d-block"
                source="theme03/group-img.webp"
                alt="timeline"
              />
            </Col>
          </Row> */}
        </Container>

        <TimelineModal
          handleCloseModal={timeLineModalClose}
          setDatas={setTimeline}
          datas={timeLine}
          showModal={timelineModal}
        />
      </section>
    </>
  );
}

export default TimelineSection03;
